import { module } from 'modujs';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
    }

    animate() {
        const lines = this.el.querySelectorAll('.c-line');
        lines.forEach(line => {
            const max = parseInt(line.dataset.max, 10);
            const value = line.querySelector('.c-line_num_value');
            gsap.to(
                value,
                { 
                    innerText: max, 
                    duration: 4,
                    snap: 'innerText',
                    ease: "expo.out",
                }
            );
        });
    }
}
